import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '@serengeti/serengeti-common';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {


  active = 'ko-kr';

  constructor(private titleService: Title,
    private translateService: TranslateService,
    private loginService: LoginService) {
    this.changeLocales();
  }

  get locales(): any {

    switch (environment.profile) {
      case 'local':
      case 'development':
        return [
          { id: 'ko-kr', name: "한국어" },
          { id: 'en-us', name: "English" },
          { id: 'ja-jp', name: "日本語" },
          { id: 'zh-cn', name: "中國語" },
        ];
      case 'mindslab':
        return [
          { id: 'ko-kr', name: "한국어" },
          { id: 'en-us', name: "English" },
          { id: 'ja-jp', name: "日本語" },
          { id: 'zh-cn', name: "中國語" },
        ];
      case 'staging':
        return [
          { id: 'ko-kr', name: "한국어" },
          { id: 'en-us', name: "English" },
          { id: 'ja-jp', name: "日本語" },
          { id: 'zh-cn', name: "中國語" },
        ];
      case 'dpg':
        return [
          { id: 'ko-kr', name: "KOR" },
          { id: 'en-us', name: "ENG" },
          { id: 'ja-jp', name: "JPN" },
          { id: 'zh-cn', name: "CHN" },
        ];
      case 'daejeon':
      case 'incheon.product':
        return [
          { id: 'ko-kr', name: "한국어" }
        ];
      default:
        return [
          { id: 'ko-kr', name: "한국어" }
        ];
    }

  }

  findLocale(localeId: string): string {
    for (const locale of this.locales) {
      if (locale.id.indexOf(localeId) !== -1) {
        return locale.id;
      }
    }
    return null;
  }

  changeLocales(locale?: string) {
    const loginSession = this.loginService.loadLoginSession();

    if (locale) {
      this.translateService.use(locale);

      if (loginSession) {
        loginSession.locale = locale;
        this.loginService.saveLoginSession(loginSession);
      }
      this.translateService.get('home.title.' + environment.profile).subscribe((title: string) => {
        this.titleService.setTitle(title);
      });
    } else {
      if(loginSession) {
        locale = loginSession.locale;
      }
    }

    if (this.locales) {
      const translateLocales = this.locales.map((locale: any) => 'common.locale.' + locale.id);

      this.active = locale;
      this.translateService.get(translateLocales).subscribe((messages: any) => {
        this.locales.forEach((locale: any) => {
          locale.name = messages['common.locale.' + locale.id];
        });
      });
    }
  }

}
